import React, { useContext, useEffect } from "react";
import Navbar from '../components/Navbar';
import Carousel from '../components/Carousel';
import OutSourcing from '../components/outsourcing/outsourcing';
import Topbar from '../components/Topbar';
import Contact from '../components/contact/contact_body';
import { LanguageContext } from "../context/LanguageContext";

const Page = () => {
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);

  useEffect(() => {
    loadLanguageFile("OutSourcing", "outsourcing/outsourcing_lang");
  }, [language]);

  const LANGUAGE = componentLanguageData.OutSourcing || { Main: {}, FAQ: [] };
  return (
    <div>
      <title>{LANGUAGE.Main.Title}</title>
      <Topbar />
      <Navbar />
      <Carousel />
      <OutSourcing />
      <Contact />
    </div>
  );
};

export default Page;